'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _FormControl = require('@material-ui/core/FormControl');
var _FormControl2 = _interopRequireDefault(_FormControl);
var _FormHelperText = require('@material-ui/core/FormHelperText');
var _FormHelperText2 = _interopRequireDefault(_FormHelperText);
var _OutlinedInput = require('@material-ui/core/OutlinedInput');
var _OutlinedInput2 = _interopRequireDefault(_OutlinedInput);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _reactI18next = require('react-i18next');
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultMainColor = '#612f62';
var styles = {
  container: {
    backgroundColor: '#f9f9f9',
    padding: '2rem 0'
  },
  innerContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    boxShadow: '0px 0px 11px 0px rgba(221,221,221,1)',
    backgroundColor: '#ffffff',
    margin: function margin(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '0 1rem' : '0 2rem';
    },
    padding: '1.5rem',
    flexDirection: function flexDirection(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 'row' : 'column';
    }
  },
  infoGroup: {
    marginRight: function marginRight(_ref3) {
      var responsiveMode = _ref3.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '2rem' : '0';
    },
    textAlign: function textAlign(_ref4) {
      var responsiveMode = _ref4.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 'left' : 'center';
    },
    maxWidth: '30rem'
  },
  title: {
    fontWeight: 'bold',
    color: function color(_ref5) {
      var accentColor = _ref5.otherProperties.accentColor;
      return accentColor || defaultMainColor;
    },
    fontSize: 'large'
  },
  info: {
    fontSize: '14px',
    color: '#656565'
  },
  inputGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    marginLeft: function marginLeft(_ref6) {
      var responsiveMode = _ref6.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '2rem' : '0';
    },
    marginTop: function marginTop(_ref7) {
      var responsiveMode = _ref7.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '0' : '1rem';
    },
    flexDirection: function flexDirection(_ref8) {
      var responsiveMode = _ref8.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 'column' : 'row';
    },
    maxWidth: function maxWidth(_ref9) {
      var responsiveMode = _ref9.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '270px' : '600px';
    }
  },
  formControl: {
    width: function width(_ref10) {
      var responsiveMode = _ref10.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '400px' : '260px';
    },
    height: function height(_ref11) {
      var responsiveMode = _ref11.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '62px' : '90px';
    },
    margin: '0 auto'
  },
  input: {
    borderColor: "#dedede !important",
    height: '40px',
    marginTop: '-20px',
    top: '50% !important'
  },
  button: {
    backgroundColor: function backgroundColor(_ref12) {
      var accentColor = _ref12.otherProperties.accentColor;
      return accentColor || defaultMainColor;
    },
    borderRadius: '3rem',
    textTransform: 'none',
    fontSize: '14px',
    height: '40px',
    width: '200px',
    margin: function margin(_ref13) {
      var responsiveMode = _ref13.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '0.8rem auto' : '10px 16px';
    },
    '&:hover': {
      backgroundColor: function backgroundColor(_ref14) {
        var accentColor = _ref14.otherProperties.accentColor;
        return accentColor || defaultMainColor;
      }
    }
  },
  disabled: {
    backgroundColor: '#b3b3b3 !important'
  },
  progress: {
    backgroundColor: '#b3b3b3 !important',
    color: '#f9f9f9'
  },
  label: {
    fontWeight: 'bold'
  }
};
var ResumeRegistration = function (_Component) {
  _inherits(ResumeRegistration, _Component);
  function ResumeRegistration(props) {
    _classCallCheck(this, ResumeRegistration);
    var _this = _possibleConstructorReturn(this, (ResumeRegistration.__proto__ || Object.getPrototypeOf(ResumeRegistration)).call(this, props));
    _this.setEmail = function (event) {
      _this.setState({
        email: event.target.value
      });
    };
    _this.handleSubmit = function () {
      var _this$props = _this.props,
        entities = _this$props.entities,
        t = _this$props.t;
      var eventUri = Object.keys(entities).map(function (k) {
        return entities[k];
      })[0].eventUri;
      var params = {
        email: _this.state.email
      };
      _this.setState({
        sendingEmail: true
      }, function () {
        fetch(_urls2.default.getSendEditRegistrationMagicTokenUrl(eventUri), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params)
        }).then(function (response) {
          if (response.status === 200) {
            _this.setState({
              sendingEmail: false,
              errorMsg: null,
              email: '',
              successMsg: t('registration.mail_sent')
            });
          } else {
            var status = response.status;
            var errorMsg = status === 404 ? t('registration.attendee_not_found') : status === 403 ? t('registration.unable_to_modify') : t('registration.general_error');
            _this.setState({
              sendingEmail: false,
              successMsg: null,
              errorMsg: errorMsg
            });
          }
        });
      });
    };
    _this.state = {
      email: '',
      sendingEmail: false,
      errorMsg: null,
      successMsg: null
    };
    return _this;
  }
  _createClass(ResumeRegistration, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        entities = _props.entities,
        classes = _props.classes,
        t = _props.t;
      var _Object$keys$map$ = Object.keys(entities).map(function (k) {
          return entities[k];
        })[0],
        eventUri = _Object$keys$map$.eventUri,
        defaultLanguage = _Object$keys$map$.defaultLanguage,
        eventId = _Object$keys$map$.id;
      var _state = this.state,
        errorMsg = _state.errorMsg,
        successMsg = _state.successMsg;
      var labelStyle = {
        color: !!this.state.errorMsg ? '#b12d35' : '#656565'
      };
      return _react2.default.createElement('div', {
        className: classes.container
      }, _react2.default.createElement('div', {
        className: classes.innerContainer
      }, _react2.default.createElement('div', {
        className: classes.infoGroup
      }, _react2.default.createElement('p', {
        className: classes.title
      }, t('registration.already_registered_title')), _react2.default.createElement('p', {
        className: classes.info
      }, t('registration.already_registered_info'))), _react2.default.createElement('div', {
        className: classes.inputGroup
      }, _react2.default.createElement(_FormControl2.default, {
        className: classes.formControl,
        variant: 'outlined'
      }, _react2.default.createElement(_OutlinedInput2.default, {
        value: this.state.email,
        onChange: this.setEmail,
        InputProps: {
          classes: {
            root: classes.input
          }
        }
      }), _react2.default.createElement(_FormHelperText2.default, {
        className: classes.label,
        style: labelStyle
      }, (!!errorMsg || !!successMsg) && (errorMsg || successMsg))), _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        onClick: this.handleSubmit,
        disabled: this.state.sendingEmail,
        classes: {
          root: classes.button,
          disabled: classes.disabled
        }
      }, this.state.sendingEmail ? _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 15
      })) : _react2.default.createElement(_react2.default.Fragment, null, t('registration.continue_registration'))))));
    }
  }]);
  return ResumeRegistration;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(ResumeRegistration));